export default [
  {
    path: '/email',
    name: 'email',
    component: () => import('@/pages/emailList/index.vue'),
    meta: { name: '源邮箱管理' }
  },
  {
    path: '/attribute/:id',
    name: 'attribute',
    component: () => import('@/pages/emailList/attribute.vue'),
     meta: { name: ['源邮箱管理', '属性'] }
  },
  {
    path: '/emailTaskmanagement',
    name: 'emailTaskmanagement',
    component: () => import('@/pages/emailList/Taskmanagement/index.vue'),
    meta: { name: '任务管理' }
  },
  {
    path: '/emailTaskmanagement/details/:id',
    name: 'emailTaskmanagementdetails',
    component: () => import('@/pages/emailList/Taskmanagement/Taskmanagementdetails.vue'),
    meta: { name: ['任务管理', '发送明细'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/customManage/email.js